/* globals _, Backbone */
const { each, extend, keys, pick, result } = _;
const { $, View } = Backbone;

export default View.extend( {
	parent: null,

	linkFormat: ':key/:id',

	elements: {
		$trigger: '.-trigger',
	},

	listeners: {},

	findElements: function() {
		// (Re)attach each element
		each( this.elements, ( selector, name ) => {
			this[ name ] = this.$( selector );

			if ( this[ name ].length > 1 ) {
				console.warn( `[View Setup] Multiple candidates for ${name} ("${selector}") found` );
			}
		} );

		// Attach the container element, defaulting to the main one
		this.$container = $( this.$( '.-container' )[ 0 ] || this.el );
	},

	registerObjectListener: function( prop, event, method ) {
		var listeners = this._objectListeners || ( this._objectListeners = [] );

		if ( arguments.length === 2 ) {
			method = event;
			[ , prop, event ] = prop.match( /^(\S+)\s*(.*)$/ );
		}

		if ( typeof method !== 'function' ) {
			method = this[ method ];
		}

		listeners.push( [ prop, event, method ] );
	},

	listenToObjects: function() {
		if ( ! this._objectListeners ) {
			return;
		}

		this.stopListening();

		for ( let listener of this._objectListeners ) {
			const [ prop, event, method ] = listener;

			const object = result( this, prop );

			this.listenTo( object, event, method.bind( this ) );
		}
	},

	preinitialize: function( options ) {
		if ( ! options ) {
			return;
		}

		if ( typeof options.template === 'string' && options.template.match( /^#\w+$/ ) ) {
			options.template = $( options.template );
		}

		if ( options.template instanceof $ ) {
			let settings = options.template.data();
			for ( let k in settings ) {
				options[ k ] = options[ k ] || settings[ k ];
			}

			options.template = options.template.html();
		}

		if ( typeof options.el === 'string' ) {
			options.el = $( options.el );
		}

		if ( options.el instanceof $ ) {
			let settings = options.el.data();
			for ( let k in settings ) {
				options[ k ] = options[ k ] || settings[ k ];
			}
		}

		if ( options.events ) {
			options.events = extend( {}, this.events, options.events );
		}
	},

	initialize: function( options = {} ) {
		extend( this, pick( options, 'parent', 'template', 'details', 'linkFormat' ) );

		// Replace element selectors with those of any matching options
		extend( this.elements, pick( options, keys( this.elements ) ) );

		this.findElements();

		// Add any view event listeners
		if ( options.on ) {
			for ( var event in options.on ) {
				this.on( event, options.on[ event ] );
			}
		}

		// Register built-in object listeners
		for ( let event in this.listeners ) {
			this.registerObjectListener( event, this.listeners[ event ] );
		}

		// Add any additional listeners
		if ( options.listeners ) {
			for ( let event in options.listeners ) {
				this.registerObjectListener( event, options.listeners[ event ] );
			}
		}

		this.listenToObjects();
	},

	getTriggerLink: function() {
		return this.linkFormat.replace( /:(\w+)/g, ( match, attr ) => {
			return this.model.get( attr ) || this.model[ attr ];
		} );
	},

	render: function() {
		if ( ! this.el.id ) {
			this.el.id = this.cid;
		}

		var content = result( this, 'template' );
		if ( content ) {
			this.$el.html( content );
		}

		this.findElements();

		this.renderSlug();
		this.renderTriggerLink();
		this.bindDetails();

		this.trigger( 'render' );

		return this;
	},

	remove: function() {
		this.trigger( 'remove' );

		View.prototype.remove.apply( this, arguments );
	},

	renderSlug: function() {
		if ( this.model ) {
			this.$el.attr( 'data-model', this.model.getSlug() );
		}
	},

	renderTriggerLink: function() {
		if ( this.$trigger && this.$trigger.length > 0 ) {
			this.$trigger.attr( 'href', this.getTriggerLink() );
		}
	},

	bindDetails: function() {
		if ( ! this.model ) {
			return;
		}

		var bindKey = 'bind';
		if ( this.model.key ) {
			bindKey = `${this.model.key}-${bindKey}`;
		}

		this.$container.find( `[data-${bindKey}]` ).each( ( i, elm ) => {
			var $elm = $( elm );

			var [ attr, bindTo ] = $elm.data( bindKey ).split( ':' );

			var [ event, callback ] = this.model.getAttrBinding( attr, bindTo );

			var populate = model => {
				var result = callback.call( model, $elm, $elm.data() );
				if ( typeof result !== 'undefined' ) {
					$elm.fill( result, bindTo );
				}
			};

			this.registerObjectListener( 'model', event, populate );
			this.listenTo( this.model, event, populate );
			populate();
		} );
	},

	rebind: function( model ) {
		this.model = model;

		this.listenToObjects();

		this.render();

		this.trigger( 'rebind' );

		return this;
	},

	reset: function() {
		if ( this.model ) {
			this.model.reset();
		}
		this.trigger( 'reset' );
	},

	show: function() {
		this.$el.removeClass( 'hidden' );
	},

	hide: function() {
		this.$el.addClass( 'hidden' );
	},
} );
